import { spec } from '@galacean/effects';
import { concatBuffers, getBinaryType } from './utils';
/**
 * geometry 序列化
 * @param geometries
 */
export function serializeGeometries(geometries) {
    const buffers = [];
    const bufferInfo = new Map();
    let offset = 0;
    geometries.forEach(options => {
        addBuffer(options.indices?.data);
        Object.keys(options.attributes).forEach(key => {
            const { data } = options.attributes[key];
            addBuffer(data);
        });
    });
    const resultBuffer = concatBuffers(buffers, bufferInfo, offset);
    const mappedGeometries = geometries.map(props => {
        const geometryProps = { ...props };
        if (geometryProps.indices) {
            geometryProps.indices = replaceAttribute(geometryProps.indices);
        }
        geometryProps.attributes = {};
        Object.keys(props.attributes).forEach(name => {
            const attribute = props.attributes[name];
            geometryProps.attributes[name] = replaceAttribute(attribute);
        });
        return geometryProps;
    });
    return {
        data: resultBuffer,
        geometries: mappedGeometries,
        version: '1.0',
    };
    function addBuffer(buffer) {
        if (buffer && !buffers.includes(buffer)) {
            buffers.push(buffer);
            bufferInfo.set(buffer, [0, offset, buffer.byteLength, getBinaryType(buffer)]);
            offset += buffer.byteLength;
            // padding 4bytes for f32
            offset = Math.ceil(offset / 4) * 4;
        }
    }
    function replaceAttribute(attr) {
        let source;
        if (attr.data) {
            const info = bufferInfo.get(attr.data);
            if (info) {
                source = { data: [spec.ValueType.BINARY, info] };
            }
        }
        return { ...attr, ...source };
    }
}
/**
 * geometry 反序列化
 * @param geometryProps
 * @param data
 */
export function deserializeGeometry(geometryProps, data) {
    const { attributes } = geometryProps;
    const ret = { ...geometryProps };
    if (ret.indices) {
        ret.indices = { ...ret.indices };
        if (ret.indices.data) {
            // @ts-expect-error
            ret.indices.data = typedArrayFromBinary(data, geometryProps.indices?.data);
        }
        // @ts-expect-error
    }
    else if (ret.index) {
        // FIXME: 兼容编辑器导出的旧版数据
        // @ts-expect-error
        ret.indices = { ...ret.index };
        // @ts-expect-error
        if (ret.indices.data) {
            // @ts-expect-error
            ret.indices.data = typedArrayFromBinary(data, geometryProps.index?.data);
        }
    }
    Object.keys(attributes).forEach(name => {
        const attribute = attributes[name];
        const { data: pointer } = attribute;
        ret.attributes[name] = { ...attribute };
        if (pointer) {
            ret.attributes[name].data = typedArrayFromBinary(data, pointer);
        }
    });
    return ret;
}
const ctrlMap = {
    i8: Int8Array,
    u8: Uint8Array,
    i16: Int16Array,
    u16: Uint16Array,
    f32: Float32Array,
    i32: Int32Array,
    u32: Uint32Array,
};
/**
 * 重构 TypedArray，返回的 TypedArray 如果修改，会反映到原始的 ArrayBuffer 中
 * @param binaries
 * @param pointer
 */
export function typedArrayFromBinary(binary, pointer) {
    if (pointer.length != 2 || pointer[0] !== spec.ValueType.BINARY || !(pointer[1] instanceof Array)) {
        // 不是BinaryPointer，可能已经创建，直接返回
        return pointer;
    }
    const [index, start, byteLength, type] = pointer[1];
    if (!type) {
        return binary[index].slice(start, byteLength);
    }
    const CTRL = ctrlMap[type] || Uint8Array;
    return new CTRL(binary[index], start, byteLength / CTRL.BYTES_PER_ELEMENT);
}
